// IWIN-S technical data sourced from bhorukaextrusions.com/system/*
export const TYPOLOGY_DETAILS = {
  Fixed: {
    system: "IWIN-S Fixed",
    frame_depth: "50 mm",
    joints: "Outer & Inner 90°",
    glazing: "SGU 18mm (5–10mm) · DGU 32mm (22–26mm)",
    load: "65 kg max design load",
    size: "W 1500–4000 · H 900–1600 mm",
    hardware: "No moving hardware · structural glazing beads · EPDM gaskets",
    features: ["Non-operable picture window", "Sleek 50mm sightline", "6063-T6 alloy"],
  },
  Casement: {
    system: "IWIN-S Casement",
    frame_depth: "50 mm",
    joints: "Outer 90° · Inner 45°",
    glazing: "SGU 18mm · DGU 32mm",
    load: "50 kg / sash · Multipoint lock",
    size: "W 450–900 · H 750–1800 mm",
    hardware: "Friction stay hinges · multipoint espagnolette lock · lever handle · EPDM seals",
    features: ["Friction stay, up to 90° side-hung", "Child lock at 110mm", "Cleanable from indoors"],
  },
  "Top Hung": {
    system: "IWIN-S Top Hung",
    frame_depth: "50 mm",
    joints: "Outer 90° · Inner 45°",
    glazing: "SGU 18mm · DGU 32mm",
    load: "50 kg / sash · Multipoint lock",
    size: "W 450–900 · H 750–1800 mm",
    hardware: "Top-hinge friction stays · multipoint lock · restrictor arm · EPDM seals",
    features: ["Top-hinged, opens outward", "Rain-safe ventilation", "Multipoint locking"],
  },
  "Bottom Hung": {
    system: "IWIN-S Bottom Hung",
    frame_depth: "50 mm",
    joints: "Outer 90° · Inner 45°",
    glazing: "SGU 18mm · DGU 32mm",
    load: "40 kg / sash · Restrictor",
    size: "W 450–1200 · H 400–900 mm",
    hardware: "Bottom-hinge friction stays · restrictor arm · multipoint lock · EPDM seals",
    features: ["Inward bottom-hinged (hopper)", "Secure rain-safe ventilation", "Ideal for toilets & basements"],
  },
  "Tilt & Turn": {
    system: "IWIN-S Tilt & Turn",
    frame_depth: "70 mm",
    joints: "Outer 90° · Inner 45°",
    glazing: "DGU 24–32mm",
    load: "80 kg / sash · Perimeter lock",
    size: "W 500–1000 · H 700–1600 mm",
    hardware: "Dual-action tilt-turn gear · perimeter multipoint lock · concealed hinges · micro-ventilation",
    features: ["Dual action — tilt to vent, turn to clean", "High acoustic + thermal seal", "Concealed European hardware"],
  },
  "2 Track Sliding": {
    system: "IWIN-S Standard Sliding",
    frame_depth: "≈76 mm (2 track)",
    interlock: "Stiles A/B/C/D · 35mm face",
    glazing: "SGU / DGU (A–F types)",
    performance: "Wind 2500 Pa · Water 350 Pa",
    size: "Max H 2500 · shutter W 1250 mm",
    hardware: "Tandem SS rollers · touch/mortise lock · interlock brush pile · anti-lift blocks",
    features: ["2 track — 2 or 4 shutter", "Slim & strong interlock", "Optional fly-screen"],
  },
  "3 Track Sliding": {
    system: "IWIN-S Standard Sliding",
    frame_depth: "113.5 mm (141 mm with fly-screen)",
    interlock: "Stiles A/B/C/D · 35mm face",
    glazing: "SGU 18mm · DGU 32mm",
    performance: "Wind 2500 Pa · Water 350 Pa · 250 kg/leaf",
    size: "Max H 3700 · Max W 6700 mm",
    hardware: "Tandem SS rollers · mortise lock · brush pile seals · fly-screen track",
    features: ["3 track — 3 or 6 shutter", "Wide clear openings", "Optional fly-screen"],
  },
  "4 Track Sliding": {
    system: "IWIN-S 4 Track Sliding",
    frame_depth: "≈150 mm (4 track)",
    interlock: "Stiles A/B/C/D · 35mm face",
    glazing: "SGU / DGU (A–F types)",
    performance: "Wind 2500 Pa · Water 350 Pa",
    size: "Max H 2500 · shutter W 1250 mm",
    hardware: "Tandem SS rollers · mortise lock · brush pile · anti-lift blocks",
    features: ["4 track — 4 or 8 shutter", "Wide multi-panel openings", "Optional fly-screen track"],
  },
  "Corner Sliding": {
    system: "IWIN-S 90° Corner Joint",
    frame_depth: "≈76 mm",
    interlock: "Stiles A/B/C/D · 35mm face",
    glazing: "SGU / DGU",
    performance: "Wind 2500 Pa · Water 350 Pa",
    size: "Max H 2500 · shutter W 1250 mm",
    hardware: "SS rollers · corner post seal · hook lock · brush pile",
    features: ["Seamless 90° corner", "Column-free vista", "Slim interlock"],
  },
  "Sliding Door": {
    system: "IWIN-S Sliding — Big Openings",
    frame_depth: "76–141 mm",
    interlock: "E / F slim stiles",
    glazing: "SGU / DGU",
    performance: "Wind 1200 Pa · Water 200 Pa",
    size: "Up to H 3700 · shutter W 2500 mm",
    load: "150 kg / leaf",
    hardware: "Heavy-duty tandem rollers (150 kg) · hook lock · anti-lift · brush seals",
    features: ["Expansive views", "150 kg / leaf", "Integrated railing option"],
  },
  "Lift & Slide Door": {
    system: "IWIN-S Lift & Slide",
    frame_depth: "141–190 mm",
    interlock: "E / F heavy stiles",
    glazing: "DGU 24–32mm",
    performance: "Wind 2000 Pa · Water 300 Pa",
    size: "Up to H 3000 · shutter W 3000 mm",
    load: "300 kg / leaf",
    hardware: "Lift-slide gear · thumb-turn handle · SS lift trolley · thermal-break threshold",
    features: ["Effortless glide on 300 kg leaves", "Airtight when lowered", "Flush low threshold"],
  },
  "Slide & Fold Door": {
    system: "IWIN-S Slide & Fold",
    frame_depth: "≈100 mm",
    interlock: "Slim fold stiles",
    glazing: "DGU 24mm",
    performance: "Wind 1500 Pa · Water 250 Pa",
    size: "Up to H 2700 · leaf W 900 mm · 3–7 leaves",
    load: "60 kg / leaf",
    hardware: "Top-hung fold carriages · SS running gear · multipoint lock on master leaf",
    features: ["Folds fully to one/both sides", "Panoramic clear opening", "Concealed drainage"],
  },
  "French Door": {
    system: "IWIN-S French Door",
    frame_depth: "50 mm",
    joints: "Outer & Inner 90°",
    glazing: "SGU 18mm · DGU 32mm",
    load: "80 kg / leaf · Multipoint",
    size: "W 1200–1800 · H 2100–2700 mm",
    hardware: "Heavy 3-knuckle hinges · multipoint shootbolt lock · lever handle · flush bolts",
    features: ["Double leaf, no centre mullion", "Full clear opening", "Weather-sealed astragal"],
  },
  "Casement Door cum Window": {
    system: "IWIN-S Door",
    frame_depth: "50 mm",
    joints: "Outer & Inner 90°",
    glazing: "SGU 18mm · DGU 32mm",
    load: "65 kg / leaf · Multipoint + latch",
    size: "W 700–1000 · H 1800–2400 mm",
    hardware: "Heavy hinges · multipoint lock + latch · lever handle · optional door closer",
    features: ["Single or double + centre muntin", "Window over door option", "Multipoint + latch"],
  },
  "Fixed + Openable Combo": {
    system: "IWIN-S Combination",
    frame_depth: "50 mm",
    joints: "Outer 90° · Inner 45°",
    glazing: "SGU 18mm · DGU 32mm",
    load: "50 kg / sash",
    size: "W 1200–3000 · H 900–1800 mm",
    hardware: "Structural coupling mullion · friction hinges + multipoint lock on vent · fixed glazing beads",
    features: ["Fixed picture + side casement vent", "Max daylight with ventilation", "Structural coupling mullion"],
  },
  "Ventilator Louver Type": {
    system: "IWIN-S Ventilator",
    frame_depth: "50 mm",
    glazing: "6mm louver blades",
    size: "Compact openings",
    hardware: "Aluminium louver blade clips · optional exhaust fan cut-out · insect mesh",
    features: ["Louvered ventilation", "Optional exhaust cut-out", "6063-T6 alloy"],
  },
};

// Known size envelopes (mm) at 2500 Pa wind / 350 Pa water — used for gentle validation.
export const SIZE_RANGES = {
  Fixed: { wMin: 1500, wMax: 4000, hMin: 900, hMax: 1600 },
  Casement: { wMin: 450, wMax: 900, hMin: 750, hMax: 1800 },
  "Top Hung": { wMin: 450, wMax: 900, hMin: 750, hMax: 1800 },
  "Bottom Hung": { wMin: 450, wMax: 1200, hMin: 400, hMax: 900 },
  "Tilt & Turn": { wMin: 500, wMax: 1000, hMin: 700, hMax: 1600 },
  "French Door": { wMin: 1200, wMax: 1800, hMin: 2100, hMax: 2700 },
  "Casement Door cum Window": { wMin: 700, wMax: 1000, hMin: 1800, hMax: 2400 },
  "Fixed + Openable Combo": { wMin: 1200, wMax: 3000, hMin: 900, hMax: 1800 },
  "2 Track Sliding": { hMax: 2500, shutterMax: 1250 },
  "3 Track Sliding": { hMax: 3700, shutterMax: 1250 },
  "4 Track Sliding": { hMax: 2500, shutterMax: 1250 },
  "Corner Sliding": { hMax: 2500, shutterMax: 1250 },
  "Sliding Door": { hMax: 3700, shutterMax: 2500 },
  "Lift & Slide Door": { hMax: 3000, shutterMax: 3000 },
  "Slide & Fold Door": { hMax: 2700, shutterMax: 900 },
};

export function sizeWarning(typology, width, height) {
  const r = SIZE_RANGES[typology];
  if (!r) return "";
  const w = Number(width) || 0;
  const h = Number(height) || 0;
  if (!w || !h) return "";
  const msgs = [];
  if (r.wMin && w < r.wMin) msgs.push(`width < ${r.wMin}`);
  if (r.wMax && w > r.wMax) msgs.push(`width > ${r.wMax}`);
  if (r.hMin && h < r.hMin) msgs.push(`height < ${r.hMin}`);
  if (r.hMax && h > r.hMax) msgs.push(`height > ${r.hMax}mm`);
  return msgs.length ? `Outside IWIN-S limits (${msgs.join(", ")})` : "";
}
